import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Selectsearch from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';

import {
	FormGroup,
	Label,
	
} from 'reactstrap';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import { 
    allStudents,
    addHackmotionReport,
 } from 'Actions';

class AddItems extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,
    };

    UNSAFE_componentWillMount() {
        this.props.allStudents();
	}
    constructor(props) {
      
        super(props);
        this.state = {  
            seldate:'', 
            student:this.props.data.student,
            selectedFile:[], 
        };

        this.onFileChange = this.onFileChange.bind(this);
    }

    selstudent = (evt) =>{
        var stdid =evt.value;
        this.setState({ student:stdid });
    }


    selectdate = (date) => {
        const seldate =moment(new Date(date)).format('yyyy-MM-DD');
        this.setState({ seldate:date });
        
    }    

    reportHandleSubmit(event){
        event.preventDefault();
        var selectedFile = this.state.selectedFile;
        this.props.addHackmotionReport(event, selectedFile).then((data) => {   
          
           if(data.status==1){                    
               this.setState({ 
                   student:'',
                   seldate:'',
                });
  
               document.getElementById("addform").reset();    
                setTimeout(() => {
                    this.props.onClick();
                }, 2000);                   
           }
        });
        
     }
  
     onFileChange(event){
        const files = event.target.files;
        for (let i = 0; i <=files.length; i++) {
            const element = files[i];
            
            const base64 = this.convertBase64(element).then(result => this.setState({
                selectedFile: [...this.state.selectedFile, result]
            }));
        }
        
     };
  
     convertBase64 = (file) => {
           return new Promise((resolve, reject) => {
           const fileReader = new FileReader();
           fileReader.readAsDataURL(file)
           fileReader.onload = () => {
              resolve(fileReader.result);
           }
           fileReader.onerror = (error) => {
              reject(error);
           }
           })
     }
  


render() {

    const { studentlists, loading} = this.props;   
    const allstudent=studentlists.map((stdval) => {  
        return {
           label: stdval.student,  
           value: stdval.uudID
        }
    });

      return(
        <div>
             <div className="col-sm-12 col-md-6" style={{margin:"0 auto"}}>
                <RctCollapsibleCard heading="Upload Report">                        
                        <form autoComplete="off" id="addform" onSubmit={(e)=>this.reportHandleSubmit(e)}> 
                           <div className="form-group">
                                 <Label for="Select">Student *</Label>
                                 <FormGroup>    
                                       <Label for="Select">Student *</Label>                                                
                                       <Selectsearch id="student" name="student" options={allstudent} rules={{ required: 'Please select an student'}} value={allstudent.find(obj => obj.value === this.state.student)} onChange={this.selstudent} required/>
                                 </FormGroup>
                           </div>
                           <div className="form-group">
                                    <FormGroup>
                                       <Label for="date">Date *</Label>
                                       <DatePicker className="form-control" id="seldate"  name="seldate" autoComplete="off" required
                                                selected={this.state.seldate}
                                                onChange={this.selectdate}
                                                dateFormat='yyyy-MM-dd'
                                                peekNextMonth
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                             /> 
                                    </FormGroup> 
                           </div>
                           <div className="form-group">   
                              <FormGroup>
                                 <Label for="country">Report Name</Label>
                                 <input type="text" name="reportname" id="reportname" className="form-control form-control-alternative" required/>
                              </FormGroup>  
                           </div>
                           <div className="form-group">
                              <FormGroup>
                                 <Label for="Select">Upload Reports</Label>
                                 <input type="file" name="fileupl" id="fileupl" multiple onChange={this.onFileChange} className="form-control form-control-alternative" required/>
                              </FormGroup>  
                           </div>
                           <div className="form-group">
                              <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit" />
                              <input type="button" className="mr-3 mb-3 btn btn-outline-warning" onClick={this.props.onClick} value="Back" />
                           </div>                                           
                        </form>
                </RctCollapsibleCard> 
             </div>   
        </div>
              
    )
   
}
 
}

const mapStateToProps = ({ mostlyused}) => {
    const { studentlists, loading } = mostlyused;
    return { studentlists, loading };
   
}


export default connect(mapStateToProps, {
    allStudents,
    addHackmotionReport,
})(AddItems);
